import { Fragment, useState } from "react"
import { Modal, Form, Select, Input, DatePicker, Upload, Button, message } from "antd"
import { PlusOutlined } from '@ant-design/icons'
import { useForm } from "antd/lib/form/Form"
import TextArea from "antd/lib/input/TextArea"
import { baseAxiosComplete } from "../../../tool/axios"
import { apiPrefix } from '../../../js/config'
import { ngetBase64 } from '../../../js/globalParam'
import _ from 'lodash'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 }
}

interface Prop {
    serviceRecord?: ServiceRecord
    onChange?: () => void
}

interface ServiceRecord {
    work_id: string, // 上单标识
    nursing_care_type: number // 护理模式
    nursing_care_type_desc: string // 护理模式描述
    belong_nursing_name: string  // 护理师
    service_status: number // 服务状态
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
    service_days: number // 服务天数
}

export default function (prop: Prop) {

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const [isRefund, setIsRefund] = useState<number>(0)
    const [refundList, setRefundList] = useState<any[]>([])

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e && e.fileList
    }

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }

        setVisible(true)
    }

    const onFinish = () => {
        if (!form.getFieldValue('advance_date')) {
            message.warning('请选择下单时间')
            return false
        }

        baseAxiosComplete.post('/yuesao_center/customer/detail/handle_ahead_nursing_order', {
            work_id: prop.serviceRecord?.work_id,
            advance_date: form.getFieldValue('advance_date') ? form.getFieldValue('advance_date').format('YYYY-MM-DD HH:mm:ss') : '',
            advance_reason: form.getFieldValue('advance_reason'),
            is_refund: form.getFieldValue('is_refund'),
            refund_amount: form.getFieldValue('refund_amount'),
            refund_pic_list: form.getFieldValue('is_refund') === 1 ? form.getFieldValue('refundList').map((item: any) => { return item.response.data[0] }).toString() : ''
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    return <Fragment>
        {/* 月嫂中心 -> 客户管理 -> 客户详情 -> 办理提前下单 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>办理提前下单</Button>

        <Modal title="办理提前下单" width={500} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <p>当前护理模式：{prop.serviceRecord && prop.serviceRecord?.nursing_care_type_desc}</p>
            <p>当前护理师：{prop.serviceRecord && prop.serviceRecord?.belong_nursing_name}</p>
            <p>开始日期：{prop.serviceRecord && prop.serviceRecord?.service_start_date}</p>
            <p style={{ fontWeight: 'bold', fontSize: 14, color: 'red' }}>注意：请确认护理师下单信息再提交表单！</p>

            <Form form={form} {...formItemLayout} style={{ marginTop: 20 }} >
                <Form.Item required name="advance_date" label="提前下单时间" >
                    <DatePicker showTime />
                </Form.Item>

                <Form.Item required name="advance_reason" label="提前下单原因" >
                    <TextArea style={{ height: 100 }} />
                </Form.Item>

                <Form.Item label="是否退款" name="is_refund" required>
                    <Select style={{ width: 156 }} onChange={(v: number) => {
                        setIsRefund(v)
                    }}>
                        <Option key={1} value={1}>是</Option>
                        <Option key={0} value={0}>否</Option>
                    </Select>
                </Form.Item>

                {isRefund === 1 && <Fragment>
                    <Form.Item label="退款金额" name="refund_amount" required>
                        <Input style={{ width: 156 }} />
                    </Form.Item>
                </Fragment>}

                {isRefund === 1 && <Fragment>
                    <Form.Item
                        label="收款凭证"
                        valuePropName="fileList"
                        getValueFromEvent={uploadFile}
                        name="refundList"
                        extra="（最多可上传2张，大小不超过2M）"
                        rules={[{ required: true, message: '必须上传图片' }]}
                    >
                        <Upload
                            name="files"
                            onPreview={handlePreview}
                            data={{ fileType: 1, bucketType: 4 }}
                            action={apiPrefix + '/global/upload_pic'}
                            listType="picture-card"
                            fileList={refundList}
                        >
                            {uploadButton}
                        </Upload>
                    </Form.Item>
                </Fragment>}
            </Form>
        </Modal>
    </Fragment>
}